import {
  DTNode,
  DTSequenceNode,
  SequenceNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from 'common/src/modules/campaignVersions/utils/trimDescription';

export function serializeSequenceNode(node: DTNode, newNode: ServerNode) {
  const sequenceNode = node as DTSequenceNode;

  return {
    ...newNode,
    description: trimDescription(newNode.description),
    maxRepeats: sequenceNode.maxRepeats,
    outputs: (sequenceNode.outputs as SequenceNodeOutputData[]).map(
      ({nodeId, maxRepeats, id, name, type}) => {
        return {
          nodeId,
          maxRepeats,
          id,
          name,
          type,
        };
      },
    ),
  };
}
